import { withErrorHandler } from '@/error-handling';
import AppErrorBoundaryFallback from '@/error-handling/fallbacks/App';

import AppRoutes from './Routes';

const App = withErrorHandler(AppRoutes, AppErrorBoundaryFallback);

export default App;
